<template>
  <div class="col-12 mx-auto mt-4">
    <div class="row">
      <div class="col-12 col-md-5">
      <p class="text-left">
        <img alt="Dr Wisniewska" src="../assets/dr_wisniewska.jpg" class="img-fluid pt-2">
      </p>
      </div>
      <div class="col-12 col-md-7 text-justify">
        <h4 class="text-left pt-3 pb-3">O Mnie</h4>
        <p>{{ tekst1 }}</p>
        <p>{{ tekst2 }}</p>
        <p>{{ tekst3 }}</p>
        <p>{{ tekst4 }}</p>
        <h6 class="text-center">{{ language }}</h6>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      tekst1: 'Dr Małgorzata Beata Wiśniewska to lekarz pediatra, która dzięki profesjonalizmowi i indywidualnemu podejściu do każdego pacjenta, skutecznie dba o stan zdrowia dzieci od momentu ich przyjścia na świat, aż do osiągnięcia przez nie dojrzałości. Jest absolwentką Warszawskiej Akademii Medycznej. Nieustanne doskonalenie wiedzy z zakresu pediatrii i neonatologii zaowocowało w 1997 roku uzyskaniem przez dr Wiśniewską II stopnia specjalizacji z pediatrii.',
      tekst2: 'Od tego momentu dr Wiśniewska z powodzeniem prowadziła oddział dziecięcy i noworodkowy oraz poradnię konsultacyjną. Pani doktor posiada długoletni staż pracy  w lecznictwie zamkniętym i otwartym w Polsce. Od 2006 roku z zaangażowaniem pracowała  na dziecięcym oddziale noworodkowym w Hiszpanii. Natomiast od 2015 roku praktykuje na terenie Anglii. Wartym podkreślenia jest fakt, że mimo osiągniętych sukcesów zawodowych dr Wiśniewska regularnie bierze udział w różnorodnych szkoleniach z zakresu pediatrii i tym samym stale podnosi poziom swej spektakularnej wiedzy medycznej.',
      tekst3: 'Dr Wiśniewska to również absolwentka studiów podyplomowych z zakresu Medycyny Estetycznej na Uniwersytecie Medycyny i Pielęgniarstwa w Kordobie (Hiszpania). Dzięki gruntownemu wykształceniu i praktyce zdobyła profesjonalne przygotowanie do przeprowadzania zabiegów.',
      tekst4: 'Czynny udział w corocznych kongresach Medycyny estetycznej w Europie oraz w  szkoleniach z zakresu medycyny estetycznej dla zaawansowanych, pozwala Pani doktor na  poznaje nowych technik i produktów wchodzących na rynek.',
      language: 'Dr Wiśniewska prowadzi konsultacje w języku polskim, angielskim oraz hiszpańskim.'
    }
  }
}
</script>
<style lang="scss" scoped>
p {
  word-spacing: -1px;
  line-height: 1.5em;
  }
</style>
